import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { ElearningParamType } from '@/pages/Module/routes';
import { useGetElearningQuery, useGetThemesQuery } from '@/modules/services';
import { useErrorHandler } from 'react-error-boundary';
import { ModuleSetupForm } from '@/pages/Module/Setup/form';
import { Spinner } from 'elmo-elements';

const ModuleSetup = (): ReactElement => {
  const handleError = useErrorHandler();
  const { elearningId } = useParams<ElearningParamType>();

  const elearning = useGetElearningQuery(elearningId);
  const themes = useGetThemesQuery();

  if (elearning.isError) {
    handleError(elearning.error);
  }

  if (themes.isError) {
    handleError(themes.error);
  }

  if (
    elearning.isLoading ||
    themes.isLoading ||
    !elearning.data ||
    !themes.data
  )
    return <div aria-label="Elearning Loading" />;

  if (elearning.isError || themes.isError) {
    return <Spinner />;
  }

  return <ModuleSetupForm elearningData={elearning.data} />;
};

export default ModuleSetup;
